import axios from "axios";

export default class BaseService {

    apiPath: string;

    constructor(apiPath) {
        this.apiPath = apiPath;
    }

    async getAll(argumento = {},) {
        return await axios.get(`/${this.apiPath}`, { params: argumento })
    }

    async getById(id, argumento = {}) {
        return await axios.get(`/${this.apiPath}/${id}`, { params: argumento })
    }

    async postCreate(data) {
        return await axios.post(`/${this.apiPath}`, data)
    }

    async put(id, data) {
        return await axios.put(`/${this.apiPath}/${id}`, data)
    }

    async delete(id) {
        return await axios.delete(`/${this.apiPath}/${id}`)
    }

}
